import { captureException } from '@sentry/nextjs';
import { z } from 'zod';
import { isProduction } from './environment';

export const zodParse = (
  ZodSchema: z.ZodTypeAny,
  unparsedData: any,
  schemaName: string,
) => {
  const result = ZodSchema.safeParse(unparsedData);

  if (!isProduction() && !result.success) {
    const error = result.error.toString();
    console.error(error);
    throw new Error(error);
  }

  if (!result.success)
    captureException(
      new Error(
        `Zod parsing error (${schemaName}): ${result.error.toString()}`,
      ),
    );

  return result.success ? result.data : unparsedData;
};
